import { render, staticRenderFns } from "./WeekOfYear.vue?vue&type=template&id=21cdd9c4&scoped=true&"
import script from "./WeekOfYear.vue?vue&type=script&lang=js&"
export * from "./WeekOfYear.vue?vue&type=script&lang=js&"
import style0 from "./WeekOfYear.vue?vue&type=style&index=0&id=21cdd9c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cdd9c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VDivider,VList,VMenu,VRow,VSelect})
